import image from "../assets/ford.jpg";
import { ArrowsDownUp, Trash } from "tabler-icons-react";
import { useContext } from "react";
import { MenuContext } from "../context/menuContext";
import TextInput from "../utils/TextInput";

function SingleCTA() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
					: "absolute top-[3rem] md:left-[13rem] lg:left-64 md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
			}>
			<h1 className="mb-3 py-1 text-slate-500 dark:text-darktext uppercase font-semibold border-b border-b-slate-100 dark:border-b-darkborder px-5">
				Single CTA
			</h1>
			<div className="flex flex-col px-5">
				<h1 className="text-slate-500 dark:text-darktext font-medium">
					CTA Details
				</h1>
				<div className="flex flex-col mt-3 w-full gap-y-5 pb-10">
					<div className="mb-7">
						<TextInput labelText="Content" />
					</div>
					<div className="space-y-2">
						<span className="text-slate-600 dark:text-darktext">
							Main image
						</span>
						<div className="border dark:border-darkborder bg-white dark:bg-darkbg py-2 pt-0 rounded-md">
							<input
								type="file"
								className="border-b dark:border-b-darkborder block w-full text-sm text-slate-500 file:mr-4 file:py-1 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-sky-50 file:text-sky-500 hover:file:bg-sky-100 px-2 py-1"
								accept="image/jpg,image/png,image/jpeg"
							/>
							<div className="flex justify-center bg-slate-200 dark:bg-darkborder">
								<img
									className="w-[30rem] h-[35rem] py-3 object-cover bg-white"
									src={image}
									alt="main image"
								/>
							</div>
						</div>
					</div>
					<div className="flex space-x-2">
						<button className="flex items-center bg-green-500 rounded-sm text-white px-2 py-1 hover:bg-green-600 transition-all duration-150 ease-in-out ml-auto">
							<ArrowsDownUp size={17} className="mr-1" /> Update
						</button>
						<button className="flex items-center bg-red-500 rounded-sm text-white px-2 py-1 hover:bg-red-600 transition-all duration-150 ease-in-out">
							<Trash size={17} className="mr-1" /> Delete
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SingleCTA;
